import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Image from 'react-bootstrap/Image';
import Dropdown from 'react-bootstrap/Dropdown';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { languageObject, removeLanguageFromPathname } from '../../utils/languages';
import { language$, setLanguage, updateUserSettings } from '../../store/slices/user';
import i18n from '../../i18n';
import { useAppDispatch, useAppSelector } from '../../types/hooks';
import { colors } from '../../utils/colors';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_ROUTES, languages } from '../../routes';
import {
    FlagDa,
    FlagDe,
    FlagEl,
    FlagEn,
    FlagEs,
    FlagFi,
    FlagFr,
    FlagGb,
    FlagGr,
    FlagIt,
    FlagNb,
    FlagNo,
    FlagPl,
    FlagSe,
    FlagSv,
    MinifinderLogoWhite,
} from '@minifinder/resources/images';

const GuestHeader = () => {
    const d = useAppDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const languageS = useAppSelector(language$);
    const [language, setUserLanguage] = useState(languageS ?? 'en');

    useEffect(() => {
        const browserLanguage = window.location.pathname?.split('/')[1];
        const currentLanguage = languages.includes(browserLanguage) ? browserLanguage : 'en';

        if (currentLanguage && currentLanguage !== language) {
            setUserLanguage(currentLanguage);
            d(setLanguage(currentLanguage));
            d(updateUserSettings({ setting: 'language', value: currentLanguage }));
            i18n.changeLanguage(currentLanguage);
        }
    }, [language, pathname]);

    const onChangeLanguage = useCallback(
        (language: string) => {
            setUserLanguage(language);
            d(setLanguage(language));
            d(updateUserSettings({ setting: 'language', value: language }));
            i18n.changeLanguage(language);
            let path = removeLanguageFromPathname(pathname);

            if (path !== APP_ROUTES.login || path !== APP_ROUTES.forgot || path !== APP_ROUTES.home) {
                path = '';
            }

            navigate(`/${language}${path}`);
        },
        [pathname],
    );

    const Flag = useMemo(() => {
        switch (language) {
            case 'da':
                return FlagDa;
            case 'de':
                return FlagDe;
            case 'el':
                return FlagEl;
            case 'en':
                return FlagEn;
            case 'es':
                return FlagEs;
            case 'gb':
                return FlagGb;
            case 'it':
                return FlagIt;
            case 'fr':
                return FlagFr;
            case 'fi':
                return FlagFi;
            case 'pl':
                return FlagPl;
            case 'gr':
                return FlagGr;
            case 'sv':
                return FlagSv;
            case 'se':
                return FlagSe;
            case 'no':
                return FlagNo;
            case 'nb':
                return FlagNb;
            default:
                return FlagEn;
        }
    }, [language]);

    return (
        <Navbar fixed="top" expand="lg" bg="dark" data-bs-theme="dark" className="h-nav-landing">
            <Container fluid>
                <Navbar.Brand>
                    <Image style={{ height: 20, verticalAlign: 'inherit' }} src={MinifinderLogoWhite} />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-between">
                    <Nav className="me-auto">
                        {/* <Nav.Link className="h-nav-link" href={`/${language}${APP_ROUTES.support}`}>
                            {t('web.landing.header.support')}
                        </Nav.Link> */}
                    </Nav>
                    <Nav>
                        <Dropdown className="ms-3 ">
                            <Dropdown.Toggle variant="dark" id="dropdown-basic" className="guest-nav-toggle">
                                <img alt="" src={Flag} className="guest-toggle-nav-img" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {languageObject.map((ln) => {
                                    return (
                                        <Dropdown.Item key={ln.code} onClick={() => onChangeLanguage(ln.code)}>
                                            <span
                                                style={{ color: ln.code === language ? colors.miniRed : colors.white }}
                                            >
                                                {ln.label}
                                            </span>
                                        </Dropdown.Item>
                                    );
                                })}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default GuestHeader;
